/*************************************************************************************/
/*									jQuery Events
/*************************************************************************************/
//var loaded_apps = false;
$(window).on('load', function () {
  ScrollToHash();
  DetectUrlParameters();
  //ScrollBackgroundX(".featured-in-wrapper");

  //apps
  InitCustomLocationBasedRules();
  LoadCalendarStart();

  //load cart properties
  PopulateCartAttributes();

  // var banner_msg = '🎄 Free shipping in the US for the rest of the month. Happy holidays! 🌟';
  // AddSlideToTopHeaderBanner("free-shipping-over", banner_msg);
});

$(document).ready(function () {
  AnimateElementsOnLoad();
  //Responsive();
});

$(window).resize(function () {
  Responsive();
});

$(window).scroll(function () {
  AnimateWhenVisible();
  Responsive();
});

/*************************************************************************************/
/*									Main Functions
/*************************************************************************************/

var bake_date;
var delivery_date;
var customer_note;
var corp_name;
var ship_asap;
var zip_code;

function PopulateCartAttributes() {
  zip_code = $.cookie('selected_zip_code');

  debug.func(console_pre + arguments.callee.name, console_colors);
  debug.log('Ajax Start: get cart atts');
  var params = {
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    beforeSend: function () {},

    success: function (data) {
      var attributes = data['attributes'];
      zip_code = $.cookie('selected_zip_code');

      if (attributes) {
        if (attributes['Bake Date']) {
          bake_date = attributes['Bake Date'];
        }
        if (attributes['Preferred Delivery Date']) {
          delivery_date = attributes['Preferred Delivery Date'];
        }
        if (attributes['Gift Note']) {
          customer_note = attributes['Gift Note'];
        }
        if (attributes['corp_name']) {
          corp_name = attributes['corp_name'];
          $('.corporate-form .input_name').val(corp_name);
        }
        if (attributes['Ship ASAP']) {
          ship_asap = JSON.parse(attributes['Ship ASAP']);
        }

        debug.log('Ajax End: get cart atts');
        debug.log(attributes);

        if (customer_note) {
          $('.add_order_notes').html('Edit Gift Note');
          $('.order_notes_input_wrapper .note_input').val(customer_note);
          $('.corporate-form .input_gift_note').val(customer_note);
        } else {
          $('.add_order_notes').html('Add Gift Note');
        }

        debug.log('SHIP ASAP: ' + ship_asap);
        debug.log('selected_zip_code cookie: ' + zip_code);

        if (zip_code) {
          EnteredZipCode(zip_code);
        }
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest);
      //Shopify.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
}

/*------------------------------------------------------------------------------------								
                  General									 
-------------------------------------------------------------------------------------*/
setDebug(custom_console);

function setDebug(isDebug) {
  if (isDebug) {
    window.debug = {
      log: window.console.log.bind(window.console, '%o'),
      error: window.console.error.bind(window.console, '%s'),
      info: window.console.info.bind(window.console, '%s'),
      warn: window.console.warn.bind(window.console, '%s'),
      func: window.console.log.bind(window.console, '%s'),
    };
  } else {
    var __no_op = function () {};

    window.debug = {
      log: __no_op,
      error: __no_op,
      warn: __no_op,
      info: __no_op,
      func: __no_op,
    };
  }
}

function AnimateWhenVisible() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  $('.animation.when-visible')
    .not('.loaded')
    .each(function (index, element) {
      var anim_elem = this;
      var top_of_element = $(anim_elem).offset().top;
      var bottom_of_element =
        $(anim_elem).offset().top + $(anim_elem).outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();
      if (
        bottom_of_screen > top_of_element &&
        top_of_screen < bottom_of_element
      ) {
        Animate(anim_elem);
      } else {
      }
    });
}

var scroll_background_x_pos = 0;
var scroll_background_x_speed = 10000;
function ScrollBackgroundX(jquery_selector) {
  scroll_background_x_pos += 100;
  $(jquery_selector).css(
    'background-position',
    scroll_background_x_pos + '% 0%'
  );
  setTimeout(function () {
    ScrollBackgroundX(jquery_selector);
  }, scroll_background_x_speed);
}

function DetectSavedCookies() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  var customer_note = $.cookie('Gift Notes');
  if (customer_note) {
    $('.add_order_notes').html('Edit Gift Note');
  } else {
    $('.add_order_notes').html('Add Gift Note');
  }
  $('.order_notes_input_wrapper .note_input').val(customer_note);
  $('.corporate-form .input_gift_note').val(customer_note);
}

function DetectUrlParameters() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  var cart = getUrlParameter('cart');
  if (cart == 'true') {
    $('#cart-icon-bubble').trigger('click');
  }
  var from = getUrlParameter('from');
  if (from == 'subscription') {
    $('html, body').animate(
      {
        scrollTop: $('.choose_your_own_cookies_filter').offset().top,
      },
      600
    );
  }
  var layout = getUrlParameter('layout');
  if (layout == 'corporate') {
    if ($("body[rel='choose-your-own-cookies'").length != 0) {
      RemoveOrderAttributes();
      $('.banner-size-picker').hide();
      $('.corporate-form.window-popup-up').show();
      $('.pink-overlaybg').fadeIn();
    }
  }
  //if subbed the minumun amount to unlock 1 month
  var subbed_min = getUrlParameter('subbed_min');
  if (subbed_min == 'true') {
    $('.subscription-buy-wrapper .plans_buttons_ul li:nth-of-type(4)').show();
  }

  //>cookie club member try
  var try_cookie_club = getUrlParameter('try_cookie_club');
  var additional_days = 0;
  if (try_cookie_club == 'true') {
    $.ajax({
      url: 'https://taylorchipdev.com/dev/web/functions/promos/promo5.php',
      data: { func: 'Submit' },
      type: 'POST',
      success: function (data) {
        if (data) {
          if (JSON.parse(data)) {
            var json_data = JSON.parse(data);
            console.log(json_data);

            var date1 = '2025-05-28 00:00:00';
            var date2 = '2025-05-31 23:59:00';

            // Parse the date strings into Date objects
            var dateObj1 = new Date(date1.replace(' ', 'T'));
            var dateObj2 = new Date(date2.replace(' ', 'T'));

            dateObj2.setDate(dateObj2.getDate() + additional_days);
            //dateObj2.setDate(dateObj2.getDate() + 1);
            // Calculate the difference in milliseconds
            var diffMs = dateObj2 - dateObj1;

            var timer_response = msToText(diffMs);

            $('.try_cookie_club_banner').show();
            $('.try_cookie_club_banner .content *[data-date]').text(
              timer_response
            );

            $('.try_cookie_club_banner').attr('data-timer', diffMs);

            if (diffMs <= 0) {
              $('.try_cookie_club_banner .content *[data-date]').text(
                'COUPON EXPIRED'
              );
              $('body').attr('data-subscribed', 'false');
            } else {
              $('.join-cookie-club-product-link').hide();

              $(
                '.choose__your__own__single__cookie_wrapper.can_add_to_cart.MembersOnly .join-cookie-club-product-link'
              ).hide();
              $(
                '.choose__your__own__single__cookie_wrapper.can_add_to_cart.MembersOnly .prod-quantity'
              ).show();

              $('.product-page .pdp-left-col').css(
                'padding',
                '180px 65px 52px'
              );

              $('.product-page-wrapper').css('padding-top', '180px');
            }

            setInterval(deductMinuteFromCookieClubTry, 60000);
            //setInterval(deductMinuteFromCookieClubTry, 10);
          }
        }
      },
      error: function () {},
      complete: function () {},
    });
  }
}

function msToText(ms) {
  // Calculate the difference in days, hours, and minutes
  var diffDays = Math.floor(ms / (1000 * 60 * 60 * 24));
  var diffHrs = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var diffMins = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));

  var timer_response =
    diffDays + ' days, ' + diffHrs + ' hours and ' + diffMins + ' minutes';
  return timer_response;
}

function deductMinuteFromCookieClubTry() {
  var ms = $('.try_cookie_club_banner').attr('data-timer');
  ms -= 60000;

  $('.try_cookie_club_banner').attr('data-timer', ms);
  var timer_response = msToText(ms);

  if (ms <= 0) {
    $('.try_cookie_club_banner .content *[data-date]').text('COUPON EXPIRED');
    $('body').attr('data-subscribed', 'false');

    $(
      '.choose__your__own__single__cookie_wrapper.can_add_to_cart.MembersOnly .join-cookie-club-product-link'
    ).show();
    $(
      '.choose__your__own__single__cookie_wrapper.can_add_to_cart.MembersOnly .prod-quantity'
    ).hide();
  } else {
    $('.try_cookie_club_banner .content *[data-date]').text(timer_response);

    $(
      '.choose__your__own__single__cookie_wrapper.can_add_to_cart.MembersOnly .join-cookie-club-product-link'
    ).hide();
    $(
      '.choose__your__own__single__cookie_wrapper.can_add_to_cart.MembersOnly .prod-quantity'
    ).show();
  }
}

function AnimateElementsOnLoad() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  $('.anim-on-load').each(function (index, element) {
    var anim_elem = this;
    var delay = $(anim_elem).data('delay');
    setTimeout(function () {
      Animate(anim_elem);
    }, parseInt(delay));
  });
}

function ScrollToHash() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  var urlHash = window.location.href.split('#')[1];
  var header_height = $('#shopify-section-header').height();
  if (urlHash && $('#' + urlHash).length) {
    $('html,body').animate(
      {
        scrollTop: $('#' + urlHash).offset().top - header_height,
      },
      100
    );
  }
}

function Responsive() {
  $('.full-height').each(function (index, element) {
    var stop_past = $(this).data('stop-past');
    var scroll_pos = $(window).scrollTop();
    if (stop_past) {
      if (scroll_pos > stop_past) {
        return;
      }
    }

    var header_height = $('#shopify-section-header').height();
    var full_height = window.innerHeight - header_height + 'px';
    $(this).css('max-height', full_height);
  });

  $('.full-height-mobile').each(function (index, element) {
    if ($(window).width() < 750) {
      var header_height = $('#shopify-section-header').height();
      var full_height = window.innerHeight - header_height + 'px';
      $(this).css('max-height', full_height);
    }
  });

  $('#cart-notification').each(function (index, element) {
    if ($(window).width() < 750) {
      var full_height = window.innerHeight + 'px';
      $(this).css('max-height', full_height);
    }
  });
}

function Animate(anim_elem) {
  var anims = $(anim_elem).data('anims').split(' ');
  for (i = 0; i < anims.length; i++) {
    var anim = anims[i];
    $(anim_elem).addClass(anims[i]);
  }
  $(anim_elem).addClass('loaded');
}

function closeOverlay() {
  $('.pink-overlaybg').fadeOut();
  $('.cookie__description').hide();
}

function openOverlay() {
  $('.pink-overlaybg').fadeIn();
}

/*------------------------------------------------------------------------------------								
                  Date Picker									 
-------------------------------------------------------------------------------------*/

/*

function AddNotes(){
  if ($("#calendar_wrapper td .date_note").length == 0) {
    $("#calendar_wrapper td").append('<p class="date_note">...</p>');
  } 
  $("#calendar_wrapper td .date_note").text('');

  $.each(orders_occurrences, function( index, value ) {

    var date = value["preferred_delivery_date"].split(' ')[0];
    var num_of_orders = value["occurrence"];

    var arr_dateText = date.split("-");
    var date_year = parseInt(arr_dateText[0], 10);
    var date_month = parseInt(arr_dateText[1], 10);
    var date_day = parseInt(arr_dateText[2], 10);

    if(loaded_month == date_month && loaded_year == date_year){
      if(num_of_orders >= max_orders_per_day){        
        var matching_day = $("#calendar_wrapper td .ui-state-default").filter(function() {
          return $(this).text() == date_day;
        });
        matching_day.siblings(".date_note").text(num_of_orders + "/" + max_orders_per_day);
        matching_day.closest("td").addClass("ui-datepicker-unselectable ui-state-disabled undefined");
      }
    }
  }); 

  
  //UpdateCalendarAvailability();

}
*/

/*------------------------------------------------------------------------------------								
                  Cart / Checkout								 
-------------------------------------------------------------------------------------*/
function ProductDetailsPopup(elem) {
  debug.func(console_pre + arguments.callee.name, console_colors);
  let cookie_title = elem
    .closest('.data_wrapper')
    .find('.cookie-data')
    .data('title');
  let cookie_description = elem
    .closest('.data_wrapper')
    .find('.data-description')
    .html();
  let cookie_images = elem
    .closest('.data_wrapper')
    .find('.cookie-data')
    .find('.cookie-images-ul li');
  let cookie_metafields = elem
    .closest('.data_wrapper')
    .find('.data-metafields')
    .html();
  let product_buttons = elem
    .closest('.card-information')
    .find('.card-information-actions')
    .parent()
    .html();
  $('.thumbnail-images-container').empty();
  $('.cookie-detail-main-image-container').empty();
  $(cookie_images).each(function (i, li) {
    var image = $(li);
    image = image.data('image-url');
    $('.thumbnail-images-container').append(
      '<div class="thumb-cookie-wrapper"><img class="thumb-cookie" src="' +
        image +
        '"/><i></i></div>'
    );
  });
  let main_image = $(cookie_images[0]);
  $('.cookie-detail-main-image-container').append(
    '<img src="' + main_image.data('image-url') + '"/>'
  );
  $('.cookie-details-text-content .product-title').html(cookie_title);
  $('.cookie-details-text-content .p').html(cookie_description);
  $('.cookie-details-text-content .cookie-metafields').html(cookie_metafields);
  $('.cookie-details-text-content .product-buttons').html(product_buttons);
  $('.thumb-cookie-wrapper:first-of-type').addClass('active');
  $('.cookie__description').show();
  openOverlay();
}

function Checkout() {
  GoToCheckout();
}

$('.corporate-order-form').submit(function (e) {
  e.preventDefault();
  var gift_note = $(this).find('.input_gift_note').val();
  $('.order_notes_input_wrapper .note_input').val(gift_note);
  $('.corporate-form.window-popup-up').hide();
  $('.pink-overlaybg').fadeOut();
});

var preparation_time = 0;
function UpdateOrderAttributes() {
  debug.func(console_pre + arguments.callee.name, console_colors);
  $('.next-checkout-button').text('Loading...');
  $('.next-checkout-button').addClass('disabled');

  var calendar_date = $('#calendar_wrapper').datepicker('getDate');
  var date_db_format = $.datepicker.formatDate('yy-mm-dd', calendar_date);

  var deliveryDate = date_db_format;
  var bakeDateFormatted;

  var cake_in_cart = isThereCakeInCart();
  if (cake_in_cart) {
    var arr_dateText = deliveryDate.split('-');
    var date_year = parseInt(arr_dateText[0], 10);
    var date_month = parseInt(arr_dateText[1], 10) - 1;
    var date_day = parseInt(arr_dateText[2], 10);
    var bakeDate = new Date(date_year, date_month, date_day);
    bakeDate.setDate(
      bakeDate.getDate() - (current_transit_time + preparation_time)
    );
    bakeDateFormatted = $.datepicker.formatDate('yy-mm-dd', bakeDate);
  } else {
    var arr_dateText = deliveryDate.split('-');
    var date_year = parseInt(arr_dateText[0], 10);
    var date_month = parseInt(arr_dateText[1], 10) - 1;
    var date_day = parseInt(arr_dateText[2], 10);
    var bakeDate = new Date(date_year, date_month, date_day);
    bakeDate.setDate(bakeDate.getDate() - (2 + preparation_time));
    bakeDateFormatted = $.datepicker.formatDate('yy-mm-dd', bakeDate);
  }

  var note = $('.order_notes_input_wrapper .note_input').val();
  var ship_asap = $('.delivery_date_radios #delivery_ship_asap').is(':checked');
  var corp_name = CleanString($('.corporate-form .input_name').val());

  //console.log(note);
  //   console.log("atts");
  //   console.log(deliveryDate);
  //   console.log(bakeDateFormatted);
  //   console.log(ship_asap);
  var data_string =
    'attributes[Bake Date]=' +
    bakeDateFormatted +
    '&' +
    'attributes[Preferred Delivery Date]=' +
    deliveryDate +
    '&' +
    'attributes[Gift Note]=' +
    note +
    '&' +
    'attributes[Ship ASAP]=' +
    ship_asap +
    '&' +
    'attributes[corp_name]=' +
    corp_name;
  debug.log('Ajax Start: cart/update');
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data_string,
    dataType: 'json',
    success: function (result) {
      debug.log('Ajax End: cart/update');
      debug.log('bakeDateFormatted: ' + bakeDateFormatted);
      debug.log('deliveryDate: ' + deliveryDate);
      debug.log('ship_asap: ' + ship_asap);
      debug.log('note: ' + note);

      if ($('.cart_delivery_tab').hasClass('active')) {
        ShowCheckoutButton();
      }

      EnableCheckOutButton();

      //set the date for cookie club products
      $('.hidden_preferred_delivery_date').val(date_db_format);
      UpdateSubscriptionsDeliveryDates(date_db_format);
      //GoToCheckout();
      //OpenCheckoutConfirmPopup();
    },
  });
}

function UpdateSubscriptionsDeliveryDates(preferred_delivery_date) {
  //loop through all subs in cart render
  var sub_items_elem = $(
    "#cart-notification-product .product-in-cart[data-sku='" +
      subscriptionItemSKU +
      "']"
  );
  var sub_items_count = sub_items_elem.length;

  $.each(sub_items_elem, function (o, item) {
    var product_id = $(item).data('product_id');
    var item_key = $(item).data('item_key');

    //add a delay to each ajax call to guarantee API call rate
    setTimeout(function () {
      var new_item_properties = {
        'Selected Subscription': $(item)
          .find(
            ".prod-properties .item_properties[rel='Selected Subscription'] .prop_value"
          )
          .attr('rel'),
        'Picked Cookies': $(item)
          .find(
            ".prod-properties .item_properties[rel='Picked Cookies'] .prop_value"
          )
          .attr('rel'),
        'Preferred Delivery Date': preferred_delivery_date,
        'Bake Date': $(item)
          .find(
            ".prod-properties .item_properties[rel='Bake Date'] .prop_value"
          )
          .attr('rel'),
      };

      var prod_data = {
        id: item_key,
        properties: new_item_properties,
      };

      var params = {
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: prod_data,
        beforeSend: function () {},

        success: function (data) {
          debug.log(product_id);
          if (sub_items_count == o + 1) {
            //subscription properties updated. update cart
            debug.log('subscription properties updated. update cart');
            const cartNotification =
              document.querySelector('cart-notification');
            cartNotification.renderContents(false);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest.responseJSON.description);
        },
      };
      jQuery.ajax(params);
    }, 400 * o);
  });
}

function OpenCheckoutConfirmPopup() {
  $('.cart-notification__close').click();
  $('.checkout-confirm-popup').slideDown();
  openOverlay();
}

function CloseCheckoutConfirmPopup() {
  $('.checkout-confirm-popup').slideUp();
  closeOverlay();
}

function RemoveOrderAttributes() {
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: 'attributes[Bake Date]=&attributes[Preferred Delivery Date]=&attributes[Note]=&attributes[Gift Note]=',
    dataType: 'json',
    success: function (result) {},
  });
  $.cookie('selected_zip_code', null);
}

function GoToCheckout() {
  window.location.href = '/checkout';
}

function GoToHome() {
  window.location.href = '/';
}

function GoToCart() {
  window.location.href = '/?cart=true';
}
function DisplayCartItems() {
  $('.cart-tabs li').removeClass('active');
  $('.cart-notification-delivery').hide();
  $('.cart-notification-product').show();
  $('.cart_items_tab').addClass('active');
  $('.cart_delivery_tab').removeClass('active');
}

function DisplayShippingTabContent() {
  $('.cart-notification-product').hide();
  $('.cart-notification-delivery').show();
  $('.cart_items_tab').removeClass('active');
  $('.cart_delivery_tab').addClass('active');
}

function OpenNotePopup() {
  $('.order_notes_input_wrapper').slideDown();
}

function CloseNotePopup() {
  $('.order_notes_input_wrapper').slideUp();
}

/*************************************************************************************/
/*									Event Functions
/*************************************************************************************/

$(document).on('click', '.top-banner', function (e) {
  //$.cookie("TC-LBR-Location", null);
  //$.cookie("selected_state", null);
});

$(document).on('click', '.label_for_radio', function (e) {
  $(this).siblings('input').click();
});

$(document).on('click', '.collapse-header', function (e) {
  var collapse_clicked = $(this).closest('.collapse');
  $($(this).closest('.collapse-limiter').find('.collapse')).each(function (
    index,
    element
  ) {
    if (collapse_clicked.is($(element).closest('.collapse'))) {
      $(element).toggleClass('active');
      $(element).find('.collapse-content').slideToggle();
    } else {
      $(element).removeClass('active');
      $(element).find('.collapse-content').slideUp();
    }
  });

  return false;
  if ($(this).closest('.collapse').hasClass('active')) {
    $(this).closest('.collapse').removeClass('active');
    $(this).closest('.collapse').find('.collapse-content').slideUp();
  } else {
    $(this).closest('.collapse').addClass('active');
    $(this).closest('.collapse').find('.collapse-content').slideDown();
  }
});

$('.slider-wrapper .left-arrow').on('click', function (evt) {
  $(this).closest('.slider-wrapper').find('.slick-prev').trigger('click');
});

$('.slider-wrapper .right-arrow').on('click', function (evt) {
  $(this).closest('.slider-wrapper').find('.slick-next').trigger('click');
});

$('.product-recommendations-slider-wrapper .actual-slider').on(
  'click',
  '.product_details_popup_link',
  function () {
    ProductDetailsPopup($(this));
    evt.preventDefault();
  }
);

$('.product_details_popup_link').on('click', function (evt) {
  ProductDetailsPopup($(this));
  evt.preventDefault();
});

$('.close__cookie__description').on('click', function (evt) {
  closeOverlay();
});

$(document).on('click', '.thumb-cookie-wrapper i', function () {
  $('.thumb-cookie-wrapper').removeClass('active');
  $(this).closest('.thumb-cookie-wrapper').addClass('active');
  let selected_image = $(this).siblings('img').attr('src');
  $('.cookie-detail-main-image-container img').attr('src', selected_image);
});

$(document).on('click', '.view_details_toggle', function (e) {
  $(this).siblings('.view_details_content').toggle();
});

$('.finalize_zip_input').on('click', function (evt) {
  var zip_code_inputted = $('#zip_code_picker').val();
  EnteredZipCode(zip_code_inputted);
});

$('.edit_zip_input').on('click', function (evt) {
  ShowZipCodePicker();
});

$(document).on('click', '.scrollto', function (e) {
  e.preventDefault();
  var header_height = $('#shopify-section-header').height();
  var rel = $(this).attr('rel');
  $('html, body').animate(
    {
      scrollTop: $('.' + rel).offset().top - header_height,
    },
    1200
  );
  return false;
});

$(document).on('click', '.next-checkout-button:not(.disabled)', function (e) {
  var checkout_error = null;

  $(
    '.cart-notification-product .product-in-cart .item_properties[rel="Picked Cookies"]'
  ).each(function (index, element) {
    var item_prop_value = $(element).find('.prop_value').html();
    if (!item_prop_value) {
      checkout_error = 'Please select cookies for your box before checking out';
    }
  });

  if (checkout_error) {
    alert(checkout_error);
    DisplayCartItems();
  } else {
    Checkout();
  }
});

$(document).on('click', '.cart-tabs .cart_items_tab', function (e) {
  DisplayCartItems();
});

// $(document).on('click', '.delivery_date_radios li', function (e) {
//   $(this).find("input").prop("checked", true);
//   DisplayShipASAPOrCalendar();
// });

$(document).on('click', '.pick-a-delivery-date-button', function (e) {
  PickDeliveryDate();
});

$(document).on('click', '.finalize_pick_date', function (e) {
  FinalizePickDate();
  //ShowZipCodeWrapper();
});

$(document).on(
  'click',
  '.cart-tabs .cart_delivery_tab, .next-delivery-button',
  function (e) {
    DisplayShippingTabContent();
    ShowZipCodeWrapper();
  }
);

$(document).on('click', '.trigger_delivery_asap', function (e) {
  ShipAsap();
});

$(document).on('click', '.trigger_delivery_pick_date', function (e) {
  PickDeliveryDate();
});

$(document).on('click', '.add_order_notes', function (e) {
  OpenNotePopup();
});

$(document).on('click', '.order_notes_input_wrapper .close-btn', function (e) {
  CloseNotePopup();
});

$(document).on('click', '.finalize_note_input', function (e) {
  //UpdateOrderNote();
  var customer_note = $('.order_notes_input_wrapper .note_input').val();
  $('.corporate-form .input_gift_note').val(customer_note);
  UpdateOrderAttributes();
  CloseNotePopup();
});

$(document).on('click', '.finalize_checkout_confirmation', function (e) {
  $('.checkout-confirm-popup .finalize_checkout_confirmation').text(
    'Loading...'
  );
  GoToCheckout();
});

$(document).on('click', '.home-popup-loc-close', function (e) {
  $('.home-popup-loc').fadeOut();
  $('.popup_bg.home-popup-loc-close').fadeOut();
});

$(document).on('click', '.home-popup-loc-open', function (e) {
  $('.home-popup-loc').fadeIn();
  $('.popup_bg.home-popup-loc-close').fadeIn();
});

$(document).ready(function () {
  var $slider = $('.css-slider'),
    $slides = $('.slides'),
    $prevBtn = $('.prev-slide'),
    $nextBtn = $('.next-slide');

  $prevBtn.click(function () {
    $slides.animate(
      {
        scrollLeft: '-=300',
      },
      'fast'
    );
  });

  $nextBtn.click(function () {
    $slides.animate(
      {
        scrollLeft: '+=300',
      },
      'fast'
    );
  });
});

/*************************************************************************************/
/*									Static Functions
/*************************************************************************************/

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function ConvertListToCommaSeperated(list) {
  list = list.toString().replaceAll(',', ', ');
  return list;
}

function imgURL(src, size, crop) {
  var new_url = '';

  if (size == 'master') {
    return src;
  }
  new_url = src
    .replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
      '.'
    )
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return '_' + size + match;
    });

  if (crop) {
    new_url = new_url
      .replace(/_(crop_center|crop_top|crop_bottom)+\./g, '.')
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
        return '_crop_' + crop + match;
      });
  }
  return new_url;
}

function parseDate(input) {
  var parts = input.match(/(\d+)/g);
  return new Date(parts[0], parts[1] - 1, parts[2]);
}
function findOcc(arr, key) {
  let arr2 = [];
  arr.forEach((x) => {
    if (
      arr2.some((val) => {
        return val[key] == x[key];
      })
    ) {
      arr2.forEach((k) => {
        if (k[key] === x[key]) {
          k['occurrence']++;
        }
      });
    } else {
      let a = {};
      a[key] = x[key];
      a['occurrence'] = 1;
      arr2.push(a);
    }
  });
  return arr2;
}

function HasCookie(cookie_name) {
  var return_val = false;
  if ($.cookie(cookie_name) != 'null' && $.cookie(cookie_name) != null) {
    return_val = true;
  }
  return return_val;
}

function CleanString(str) {
  return str.replace(/[^a-zA-Z ]/g, '');
}
